import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "@phosphor-icons/react";

const KEY = "frets_cookie_consent";

export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setVisible(true);
  }, []);

  const decide = (value) => {
    localStorage.setItem(KEY, value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div data-testid="cookie-consent"
      className="fixed bottom-4 inset-x-4 sm:left-auto sm:right-6 sm:max-w-md z-[60] rounded-2xl border border-white/10 bg-[#0F1115] text-white shadow-2xl p-5">
      <div className="flex items-start gap-3">
        <Cookie size={24} weight="bold" className="text-[#FF5A36] shrink-0 mt-0.5" />
        <div className="text-sm text-zinc-300 leading-relaxed">
          Usamos cookies necesarias para el funcionamiento y, con tu permiso, para recordar tus preferencias. Conoce más en nuestra{" "}
          <Link to="/legal/cookies" className="text-[#FF5A36] font-semibold hover:underline">Política de Cookies</Link>{" "}y{" "}
          <Link to="/legal/privacidad" className="text-[#FF5A36] font-semibold hover:underline">Privacidad</Link>.
        </div>
      </div>
      <div className="mt-4 flex items-center justify-end gap-2">
        <button data-testid="cookie-reject" onClick={() => decide("rejected")}
          className="px-4 py-2 rounded-full text-sm font-semibold text-zinc-300 hover:text-white transition-colors">
          Rechazar
        </button>
        <button data-testid="cookie-accept" onClick={() => decide("accepted")}
          className="px-5 py-2 rounded-full text-sm font-bold bg-[#FF5A36] text-white hover:bg-[#E04B2A] transition-colors active:scale-95">
          Aceptar
        </button>
      </div>
    </div>
  );
}
